import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseApiWithAuth } from "@/utilities/reduxToolkit";

export type CalendarProvider = "OUTLOOK" | "GOOGLE";

export interface CalendarConnection {
  provider: CalendarProvider;
  email: string;
  connectedAt: string;
}

export interface CalendarStatusResponse {
  connections: CalendarConnection[];
}

export interface ConnectCalendarRequest {
  code: string;
  provider: CalendarProvider;
  redirectUri: string;
}

export const calendarApi = createApi({
  ...createBaseApiWithAuth({
    reducerPath: "calendarApi",
    baseUrl: "/api/calendar",
  }),
  reducerPath: "calendarApi",
  tagTypes: ["CalendarStatus"],
  endpoints: (builder) => ({
    getCalendarStatus: builder.query<CalendarStatusResponse, void>({
      query: () => "/status",
      providesTags: ["CalendarStatus"],
    }),
    connectCalendar: builder.mutation<void, ConnectCalendarRequest>({
      query: (body) => ({
        url: "/connect",
        method: "POST",
        body,
      }),
      invalidatesTags: ["CalendarStatus"],
    }),
    disconnectCalendar: builder.mutation<void, CalendarProvider>({
      query: (provider) => ({
        url: `/connection/${provider}`,
        method: "DELETE",
      }),
      invalidatesTags: ["CalendarStatus"],
    }),
  }),
});

export const {
  useGetCalendarStatusQuery,
  useConnectCalendarMutation,
  useDisconnectCalendarMutation,
} = calendarApi;
